import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import * as XLSX from 'xlsx';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Header from "../../components/header";
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";

function LedgerReport() {
    const [data, setData] = useState([]);
    const today = new Date().toISOString().split('T')[0];
    const [date, setDate] = useState(today);
    const [groupedOrders, setGroupedOrders] = useState({});
    const [productData, setProductData] = useState([]);
    const [productDatas, setProductDatas] = useState([]);
    const [allRoutes, setAllRoutes] = useState([]); 
    const [selectedZone, setSelectedZone] = useState("all");
    const [allZones, setAllZones] = useState([]);
    const [approved, setApproved] = useState('All');
    const [selectedRoutes, setSelectedRoutes] = useState(['all']);
    const [allVnum, setAllVnum] = useState([]);
    const [selectedVnum, setSelectedVnum] = useState("all");
    const [isOpen, setIsOpen] = useState(false);

    const formatDate = (date) => {     
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${String(newDate.getDate()).padStart(2, '0')}`;
        return formattedDate;
    };

    const formatViewDate = (date) => {
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${String(newDate.getDate()).padStart(2, '0')}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${newDate.getFullYear()}`;
        return formattedDate;
    };

    // const getProducts = async () => {
    //     try {
    //         const response = await axios.post('https://api.trucoo.in/products/all-product/', {}, {
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'X-API-KEY': 'erpTrucoo'
    //             }
    //         });

    //         if(response.data.status === 'success'){
    //             //setProductData(response.data.data);
    //         }
    //     } catch (error) {
    //         console.error("Error:", error.response || error.message);
    //     }
    // };

    const getData = async (approved) => {
        try {
            const response = await axios.post('https://api.trucoo.in/orders/reports/', {date}, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            
            if (response.data.status === "success") {
                let report = [];

                if(approved === undefined || approved === '' || approved === null || approved === 'All'){
                    report = response.data.data; 
                }else{
                    report = response.data.data.filter(order => order?.status === approved);
                }
                 
                setData(report || []); 
                setDate(response.data.date);
                const grouped = groupByRoute(report);
                setGroupedOrders(grouped);

                const uniqueZones = [];
                const uniqueVnum= [];
                const products = [];
                report.forEach(order => {
                    const zone = order.dealerData.zone;
                    const zoneName = order.dealerData.zoneName;
                    const vNum = order.vNum;
                    const exists = uniqueZones.some(item => item.zone === zone && item.zoneName === zoneName);
                    const vnumExists = uniqueVnum.some(item => item.vNum === vNum);
                    if (!exists) {
                      uniqueZones.push({ zone, zoneName });
                    }
                    if (!vnumExists && vNum) {
                      uniqueVnum.push({ vNum });
                    }


                    order?.orderData?.forEach(item => {
                      const exists = products.some(product => product.id === item.item);
                      if (!exists) {
                        products.push({ productName: item.itemName, productCode: item.itemCode, id: item.item });
                      }
                    });

                    const sorted = products.sort((a, b) => Number(a.id) - Number(b.id));
                    setProductData(sorted);

                    
                });
                setAllZones(uniqueZones);
                setAllVnum(uniqueVnum);

                const routes = Object.keys(grouped);
                setAllRoutes(routes);
            } else {
                console.log("Error fetching data");
                setData([]); 
                setGroupedOrders({});
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
            setData([]); 
            setGroupedOrders({});
        }
    };

    useEffect(() => {
        getData();
        // getProducts();
    }, [date]);
    
    const changeApproved = (e) => {
        const value = e.target.value;
        setApproved(value);
        getData(value);
    };

    const getProducts = (order) => {
      const products = [];
      order?.orderData?.forEach(item => {
        console.log('item', item);
        const exists = products.some(product => product.id === item.item);
        if (!exists) {
          products.push({ productName: item.itemName, productCode: item.itemCode, id: item.item });
        }
      });

      const sorted = products.sort((a, b) => Number(a.id) - Number(b.id));
      setProductData(sorted);
    };

    const groupByRoute = (data) => {
        if (!data) return {};
        return data.reduce((acc, order) => {
            const route = order.dealerData.routes;
            if (!acc[route]) {
                acc[route] = [];
            }
            acc[route].push(order);
            return acc;
        }, {});
    }; 

    const calculateRouteTotals = (groupedOrders, productData) => {
        const routeTotals = {};
        let grandTotal = {
            products: {},       
            totalCrates: 0,
            totalLiters: 0
        };

        productData.forEach(product => {
            grandTotal.products[product.id] = { crates: 0, liters: 0 };
        });

        Object.keys(groupedOrders).forEach(route => {
            const routeTotal = {
                products: {},  
                totalCrates: 0,
                totalLiters: 0
            };

            productData.forEach(product => {
                routeTotal.products[product.id] = { crates: 0, liters: 0 };
            });

            groupedOrders[route].forEach(order => {
                order.orderData.forEach(item => {
                    const qty = parseFloat(item.qty) || 0;
                    const weight = parseFloat(item.weight) || 0;
                    const crates = parseFloat(item.crates) || 1;

                    const itemLiters = qty * crates * (weight / 1000);

                    if (routeTotal.products.hasOwnProperty(item.item)) {
                        routeTotal.products[item.item].crates += qty;
                        routeTotal.products[item.item].liters += itemLiters;
                    }

                    routeTotal.totalLiters += itemLiters;
                });
            });
            
            routeTotal.totalCrates = Object.values(routeTotal.products)
                .reduce((sum, p) => sum + p.crates, 0);
            routeTotals[route] = routeTotal;
            
            Object.keys(routeTotal.products).forEach(productId => {
                grandTotal.products[productId].crates += routeTotal.products[productId].crates;
                grandTotal.products[productId].liters += routeTotal.products[productId].liters;
            });

            grandTotal.totalCrates += routeTotal.totalCrates;
            grandTotal.totalLiters += routeTotal.totalLiters;
        });

        return { routeTotals, grandTotal };
    };

    const filteredGroupedOrders = Object.keys(groupedOrders)
        .filter(route => {
            if (!selectedRoutes.includes("all") && !selectedRoutes.includes(route)){ 
                return false;
            };
            
            const ordersInRoute = groupedOrders[route];
            
            if (selectedZone !== "all" && !ordersInRoute.some(order => order.dealerData?.zone === selectedZone)) {
                return false;
            }
            
            if (selectedVnum !== "all" && !ordersInRoute.some(order => order.vNum === selectedVnum)) {
                return false;
            }
            
            return true;
        })
        .reduce((acc, route) => {
            acc[route] = groupedOrders[route].filter(order => 
                (selectedZone === "all" || order.dealerData?.zone === selectedZone) &&
                (selectedVnum === "all" || order.vNum === selectedVnum)
            );
            return acc;
        }, {});

    const { routeTotals, grandTotal } = calculateRouteTotals(filteredGroupedOrders, productData);

    const downloadExcel = () => {
        const ws = XLSX.utils.table_to_sheet(document.getElementById('printableArea'));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Invoice Data');
        XLSX.writeFile(wb, `Daily-Report_${date}.xlsx`);
    };

    const downloadPDF = () => {
        const table = document.getElementById("printableArea");
        
        const originalStyles = {};
        const elements = table.querySelectorAll('*');
        
        // elements.forEach(el => {
        //     originalStyles[el] = {
        //         cssText: el.style.cssText,
        //     };            
        //     el.style.color = '#000';           
        //     el.style.fontSize = '12px';            
            
        //     if (el.tagName === 'TD' || el.tagName === 'TH' || el.tagName === 'TABLE') {
        //         el.style.border = '1px solid #000'; 
        //         el.style.borderCollapse = 'collapse'; 
        //     }
        // });
    
        html2canvas(table, { 
            scale: 2,
            scrollY: -window.scrollY,
        }).then((canvas) => {
            elements.forEach(el => {
                if (originalStyles[el]) {
                    el.style.cssText = originalStyles[el].cssText;
                }
            });    
            const imgData = canvas.toDataURL("image/jpeg");
            const pdf = new jsPDF("l", "mm", "a4");            
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();            
        
            const marginT = 5;
            const marginB = 10;
            const availableWidth = pdfWidth - (2 * marginT);
            const availableHeight = pdfHeight - (2 * marginB);
            
            const ratio = Math.min(availableWidth / canvas.width, availableHeight / canvas.height);
            const scaledWidth = canvas.width * ratio;
            const scaledHeight = canvas.height * ratio;
            
            pdf.addImage(imgData, "JPEG", marginT, marginB, scaledWidth, scaledHeight);
            pdf.save(`Daily-Report_${date}.pdf`);
        });
    };

    const toggleDropdown = () => setIsOpen(prev => !prev);

    const handleRouteSelection = (route) => {
        if (route === 'all') {
            setSelectedRoutes(['all']);
        } else {
            let newSelected = selectedRoutes.includes('all') ? [] : [...selectedRoutes];
            if (newSelected.includes(route)) {
                newSelected = newSelected.filter(r => r !== route);
            } else {
                newSelected.push(route);
            }
            setSelectedRoutes(newSelected.length === 0 ? ['all'] : newSelected);
        }
    };

    const isRouteSelected = (route) => selectedRoutes.includes(route) || selectedRoutes.includes('all');

    const handleVnumChange = (e) => {
        setSelectedVnum(e.target.value);
    };

    const filteredRoutes = Object.keys(groupedOrders).filter(route => {
        if (!selectedRoutes.includes("all") && !selectedRoutes.includes(route)) {
            return false;
        }

        const ordersInRoute = groupedOrders[route];

        if (selectedZone !== "all" && !ordersInRoute.some(order => order.dealerData?.zone === selectedZone)) {
            return false;
        }

        if (selectedVnum !== "all" && !ordersInRoute.some(order => String(order.vNum) === String(selectedVnum))) {
            return false;
        }

        return true;
    });

    useEffect(() => {
      if(filteredRoutes){
        filteredRoutes.map((route) => {
          groupedOrders[route].map((order) => {
            getProducts(order);
          });
        });
      }
    }, [selectedZone, selectedVnum, selectedRoutes]);


    return (
        <>
            <Header />
            <Sidebar />

            <div className="content-wrapper">
                <div className="container-full">
                    <section className="content">
                        <div className="box">
                            <div className="box-header with-border">
                                <h4 className="box-title">Daily Report</h4>
                            </div>
                          
                            <div className="box-body">
                                <div className="row mb-4">
                                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12" align="left">
                                        <input
                                            type="date"
                                            value={formatDate(date)}
                                            onChange={(e) => setDate(e.target.value)}
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12" align="center">
                                       <select 
                                         className="form-control"
                                         value={selectedZone}
                                         onChange={(e) => setSelectedZone(e.target.value)}
                                       >
                                         <option value="all">All Zones</option>
                                         {allZones.map((zone) => (
                                           <option key={zone.zone} value={zone.zone}>
                                             {zone.zoneName}
                                           </option>
                                         ))}
                                       </select>
                                    </div>

                                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12" align="center" style={{ position: 'relative' }}>
                                        <div 
                                            className="form-control"
                                            onClick={toggleDropdown}
                                            style={{ cursor: 'pointer', userSelect: 'none' }}
                                        >
                                            {selectedRoutes.includes('all') ? 'All Routes' : 
                                             selectedRoutes.length > 2 ? `${selectedRoutes.length} routes selected` : 
                                             selectedRoutes.join(', ') || 'Select Routes'}
                                        </div>

                                        {isOpen && (
                                          <div className="dropdown-menu show" style={{ minWidth: '250px', padding: '8px', overflowY: 'auto', maxHeight: '60vh' }}>
                                            <div className="mb-2 d-flex justify-content-between align-items-center border-bottom pb-2">
                                              <strong>Select Routes</strong>
                                              <button className="btn btn-sm btn-light" onClick={toggleDropdown}>
                                                ×
                                              </button>
                                            </div>

                                            {/* All Routes Checkbox */}
                                            <div className="dropdown-item py-1">
                                              <div className="form-check d-flex align-items-center">
                                                <input
                                                  type="checkbox"
                                                  className="form-check-input"
                                                  style={{ opacity: 0, position: 'absolute',left: '10px'}}
                                                  id="allRoutesCheckbox"
                                                  value="all"
                                                  checked={selectedRoutes.includes('all')}
                                                  onChange={() => handleRouteSelection('all')}
                                                />
                                                <label 
                                                  className="form-check-label ms-3" 
                                                  htmlFor="allRoutesCheckbox"
                                                  style={{ paddingLeft: '24px' }}
                                                >
                                                  All Routes
                                                </label>
                                              </div>
                                            </div>

                                            {/* Individual Routes */}
                                            {allRoutes.map((route) => (
                                              <div key={route} className="dropdown-item py-1">
                                                <div className="form-check d-flex align-items-center">
                                                  <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    style={{ opacity: 0, position: 'absolute',left: '10px'}}
                                                    id={`routeCheckbox-${route}`}
                                                    value={route}
                                                    checked={isRouteSelected(route)}
                                                    onChange={() => handleRouteSelection(route)}
                                                  />
                                                  <label
                                                    className="form-check-label ms-3"
                                                    htmlFor={`routeCheckbox-${route}`}
                                                    style={{ paddingLeft: '24px' }}
                                                  >
                                                    {route}
                                                  </label>
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        )}
                                    </div>
                                    
                                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12" align="center">
                                        <select 
                                            className="form-control" 
                                            value={selectedVnum} 
                                            onChange={handleVnumChange}
                                        >
                                            <option value="all">All Vehicles</option>
                                            {allVnum?.map((vnum, index) => (
                                                <option key={index} value={vnum.vNum}>{vnum.vNum}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12" align="center">
                                       <select 
                                         className="form-control"
                                         value={approved}
                                         onChange={(e) => {changeApproved(e)}}
                                       >
                                            <option value="All">All</option>
                                            <option value="Approved">Approved</option>
                                            <option value="Placed">Not Approved</option>
                                       </select>
                                    </div>

                                    <div className="col-xxl-2 col-xl-2 col-lg-4 col-md-6 col-12" align="right">
                                        <button onClick={downloadPDF} className="btn btn-sm btn-primary mb-3 mx-2"> 
                                            <i className="fa fa-download"></i> PDF 
                                        </button>
                                        <button onClick={downloadExcel} className="btn btn-sm btn-warning mb-3"> 
                                            <i className="fa fa-download"></i> Excel 
                                        </button>
                                        
                                    </div>
                                </div>
                              
                                <div className="table-responsive" style={{width: '100%', height: 'calc(100vh - 300px)', overflow: 'auto', padding: '0 10px 10px 10px'}}>
                                    <table style={{whiteSpace: 'nowrap'}} className="table-sm table-bordered nowrap fs-10" id="printableArea" width='100%'>
                                        <thead>
                                             <tr className="text-dark text-center" style={{ position: 'sticky', top: 0, zIndex: 2, backgroundColor: '#f8f9fa' }}>
                                                <th className='text-center' colSpan={productData.length + 8}>{formatViewDate(date)}</th>
                                            </tr>
                                             <tr className="text-dark text-center" style={{ position: 'sticky', top: 0, zIndex: 2, backgroundColor: '#f8f9fa' }}>
                                                <th>ROUTE </th>
                                                <th>DEALER</th>
                                                {productData?.map((product, index) => 
                                                    <th width="150px" key={index}>{product.productName}</th>
                                                )}
                                                <th>TOTAL CRATES</th>
                                                <th>TOTAL LTR/KG</th>
                                                <th>TYPE</th>
                                                <th>VEHICLE NO.</th>
                                                <th>REMARKS</th>
                                                <th>Approved</th>
                                            </tr>
                                        </thead>
                                       <tbody class="text-end">
                                         {filteredRoutes.map((route) => (
                                           <React.Fragment key={route}>
                                             {groupedOrders[route].map((order, index) => {
                                               let totalCrates = 0;  
                                               let totalltr = 0;

                                               return (
                                                 <tr key={index}>
                                                   {index === 0 ? (
                                                     <td rowSpan={groupedOrders[route].length + 2} className="text-start">{route}</td>
                                                   ) : null}
                                                   <td className="text-start">{order.dealerData.dealer}</td>

                                                   {productData?.map((product) => {
                                                     const orderItem = order.orderData.find((item) => item.itemCode === product.productCode);
                                                     const crates = orderItem ? parseFloat(orderItem.qty) : 0;
                                                     const ipc = orderItem ? parseFloat(orderItem.crates) : 0;
                                                     const weight = orderItem ? parseFloat(orderItem.weight) : 0;
                                                     totalltr += (crates * ipc * (weight/1000)) || 0;
                                                     totalCrates += crates;
                                                     return <td key={product.id}>{crates > 0 ? parseFloat(crates).toFixed(2) : ''}</td>;
                                                   })}

                                                   <td>{parseFloat(totalCrates).toFixed(2)}</td>
                                                   <td>{parseFloat(totalltr).toFixed(2)}</td>
                                                   <td>{order?.type.toUpperCase()}</td>
                                                   <td>{order?.vNum}</td>
                                                   <td><small>{order?.remarks}</small></td>
                                                   <td className={order.status === 'Placed' ? 'text-danger' : 'text-success'}>
                                                     <small>{order.status === 'Placed' ? 'Waiting' : order?.approved?.employeeName}</small>
                                                   </td>
                                                 </tr>
                                               );
                                             })}
                                           
                                             <tr style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                                              <td colSpan={1} className="text-start">TOTAL CRATES</td>
                                              {productData?.map((product) => (
                                                <td key={`total-crates-${product.id}`}>
                                                  {parseFloat(routeTotals[route]?.products[product.id]?.crates).toFixed(2) || '0'}
                                                </td>
                                              ))}
                                              <td>{parseFloat(routeTotals[route]?.totalCrates).toFixed(2) || '0'}</td>
                                              <td></td> <td></td> <td></td> <td></td>
                                            </tr>

                                            <tr style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                                              <td colSpan={1} className="text-start">TOTAL LITRES</td>
                                              {productData?.map((product) => (
                                                <td key={`total-liters-${product.id}`}>
                                                  {parseFloat(routeTotals[route]?.products[product.id]?.liters).toFixed(2) || '0'}
                                                </td>
                                              ))}
                                              <td></td>
                                              <td>{parseFloat(routeTotals[route]?.totalLiters).toFixed(2) || '0'}</td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                            </tr>
                                           </React.Fragment>
                                         ))}

                                         {/* Grand total row */}
                                         
                                           <tr style={{ fontWeight: 'bold', backgroundColor: '#e0e0e0' }}>
                                             <th colSpan={2} className="text-start">GRAND TOTAL (CRATES)</th> 
                                             {productData?.map((product) => (
                                               <th key={`grand-total-${product.id}`}>
                                                 {parseFloat(grandTotal?.products[product.id]?.crates || 0).toFixed(2)}
                                               </th>
                                             ))}
                                             <th>{parseFloat(grandTotal?.totalCrates).toFixed(2)}</th>
                                             <th></th>
                                            
                                             <th></th>
                                             <th></th>
                                             <th></th>
                                           </tr>
                                       
                                           <tr style={{ fontWeight: 'bold', backgroundColor: '#e0e0e0' }}>
                                             <th colSpan={2} className="text-start">GRAND TOTAL (LITRES)</th> 
                                             {productData?.map((product) => (
                                               <th key={`grand-total-${product.id}`}>
                                                 {parseFloat(grandTotal?.products[product.id].liters).toFixed(2) || '0'}
                                               </th>
                                             ))}
                                             <th></th>
                                             <th>{parseFloat(grandTotal?.totalLiters).toFixed(2)}</th>
                                            
                                             <th></th>
                                             <th></th>
                                             <th></th>
                                           </tr>
                                     
                                       </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            {/* <Footer /> */}
        </>
    );
}

export default LedgerReport;